module.exports = __webpack_public_path__ + "img/icon-project-black.5dc6938e.svg";